import React from "react";
import Grid from "@material-ui/core/Grid";
import backgroundImage from "../../../../assets/images/main_background.png";
import Fail from "../../../../assets/images/ic_faild.png";
import BlueBtn from "../../../../assets/images/blue_btn.png";
import StartButton from "../../../../components/pageComponents/Home/LeagueStart/StartButton";
import {withRouter,Redirect} from "react-router-dom";
import axios from "axios";
import {sessionNew, userData} from "../../../../Utility/Url";
import {numberSplitor} from "../../../../Utility/Func";
import PicoLoader from "../../Common/PicoLoader";
import {dialogBackground, dialogBorderColor, dialogContentColor, dialogContentTextColor
} from "../../../../Utility/Theme";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "../../Common/Dialog";
import {connect} from "react-redux";
import {data as rxData} from "../../../../Store/Actions/DataAction";
import {COINCHANGE} from "../../../../Store/Actions/Types";


class League extends React.Component{
    state={
            remainingTime:null,
            sessionValid:false,
            sessionId:undefined,
            picoSmallLoader:false,
            dialog:null,
            showDialog:false,
            seconds:3000
        }
    dateMaker=(value)=> {
        const sec = parseInt(value, 10);
        let hours   = Math.floor(sec / 3600);
        let minutes = Math.floor((sec - (hours * 3600)) / 60);
        let seconds = sec - (hours * 3600) - (minutes * 60);
        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return `${hours} ساعت ${minutes} دقیقه ${seconds} ثانیه`
    }
    componentDidMount() {
        this.setState({
            seconds:this.props.data.remSec
        })
        const today=new Date()
        const timeString=`${today.getHours()} ساعت ${today.getMinutes()} دقیقه ${today.getSeconds()} ثانیه`
        this.setState({
            remainingTime:timeString
        })
        setInterval(()=>{
                const timeString=this.dateMaker(this.state.seconds)
                this.setState({
                    remainingTime:timeString,
                    seconds:this.state.seconds-1
                })
            }
            , 1000);
       }
    sessionNew= async(id,type)=>{
            this.setState({
                picoSmallLoader:true
            })
            await axios.post(sessionNew,{
                id:id,
                type:type
            })
                .then(res => {
                    const {data}=res
                    if (!data.success){
                        this.setState({
                            dialog:data.dialog,
                            showDialog:true,
                        })
                        return false
                    }
                    const {startButtonIconText}=this.props.data
                    this.props.rxData({coinType:'golden',value:startButtonIconText,type:'decrement'},COINCHANGE)
                    this.setState({
                        sessionId:data.sessionID,
                        sessionValid:true,
                        picoSmallLoader:false
                    })
                    return true
                }).catch(error=>{
                        console.log(error.toString())
                    }
                )
    }
    handleClose=(()=>{
        this.setState({
            showDialog:false,
            picoSmallLoader:false
        })
    })
    handleDialogAction=(action)=>{
        switch (action) {
            case '#cancel':
                this.setState({
                    showDialog:false,
                    picoSmallLoader:false
                })
                break
            case '#shop':
               this.props.history.push('/shop')
                break
            default:
                this.setState({
                    showDialog:false,
                })
        }
    }
    render() {
        const {name, totalPrize, score, timeRemaining, backgroundColor, prizeIcon, startButtonImage, startButtonText, startButtonIcon, startButtonIconText, leftSectionBottomImage, leftSectionTopImage, backgroundImage, gameStart, id, gameType,
            currencyFa,imageType,
        description,hasDetails} =this.props.data
        const startButton={
            backgroundImage:startButtonImage,
            text:startButtonText,
            icon:startButtonIcon,
            iconText:startButtonIconText
        }
        const winnerTableButton={
            backgroundImage:BlueBtn,
            text:'جدول برندگان',
            icon:'',
            iconText:''
        }
        const{sessionId,sessionValid,picoSmallLoader,dialog,showDialog}=this.state
        const customDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog: {...dialog,icon:Fail,},
            }
        }

        return(
            <Grid justify={'center'}  xs={12} sm={12}  item container style={{position:'relative',backgroundImage:'red'
                ,overflow:'visible'
            }}>
                <Dialog
                    // disableBackdropClick
                    open={showDialog}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <CustomDialog action={this.handleDialogAction} data={customDialog}/>
                    </DialogContent>
                </Dialog>
                <img  className={'league-top-image'} src={leftSectionTopImage}
                      style={{}} alt=""/>
                {(() => {
                    if (this.state.remainingTime){
                        return(
                            <p className={'league-time-remaining'} style={{borderColor:backgroundColor}}>
                                <span style={{marginLeft:'5px'}}>تا اتمام لیگ</span>
                                {this.state.remainingTime}
                            </p>
                        )
                    }else {
                        return (
                            <p className={'league-time-remaining'} style={{borderColor:backgroundColor}}>
                            </p>)
                    }
                })()}
                <Grid container style={{
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize:'100% 100%',
                    backgroundRepeat: 'no-repeat',
                    width:'100%',
                    backgroundColor:backgroundColor,
                    backgroundBlendMode:'soft-light',
                    position:'relative',
                    clipPath: 'polygon(3% 0%, 97% 0px, 100% 5%, 100% 94%, 96% 101%, 3% 100%, 0px 95%, 0px 5%)'
                }}
                className={'league'} justify={"center"}
                >
                    <Grid item direction={"column"} style={{position:'relative',background:'',transform:`translateY(${hasDetails?'7%':'50%'})`}} justify={"center"} alignItems={"center"} container xs={5} sm={5}>
                        <img  className={'league-bottom-image'} src={leftSectionBottomImage} alt=""/>
                        <p  className={'league-score'}>{score}</p>
                    </Grid>
                    <Grid style={{background:''}} container direction="column" item justify="space-around" alignItems="center" xs={7} sm={7}>
                        <Grid justify='center' item container>
                            <p className={'league-name'}>
                                {name}
                            </p>
                        </Grid>
                        <Grid justify='space-around'  alignItems={"center"} item container style={{position:'relative'}} >
                            <img src={prizeIcon} className={'league-prize-icon'} alt=""/>
                            <Grid sm={11} xs={11} item container direction='row-reverse' justify={"space-around"} style={{backgroundColor:'rgba(0,0,0,0.5)'}}>
                                <Grid justify={"center"} container alignItems="center" xs={5} sm={5}>
                                    <p>
                                        مجموع جوایز
                                    </p>
                                </Grid>
                                <Grid justify={"center"} container alignItems="center" xs={5} sm={5} item >
                                    <p  className={'league-prize'}>
                                        {numberSplitor(totalPrize)}{currencyFa}
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>
                        { sessionValid &&
                        <Redirect
                            to={{
                                pathname: "/league-start/question",
                                state: { sessionId: sessionId,gameType:gameType,imageType:imageType}
                            }}
                        />
                        }
                    </Grid>
                     {
                         hasDetails &&
                         <Grid item sm={8} xs={8} style={{alignSelf:'center'}} container alignItems={"center"} justify={"center"} >
                        <Grid className={'league-paragraph'} container alignItems={"center"} justify={"center"}
                              style={{
                                  textAlign:'center',
                                  transform:'translateY(35%)'
                              }}>
                            {
                                description
                            }
                        </Grid>
                    </Grid>
                    }
                    <Grid style={{
                        transform: hasDetails ?'translate(0%, 30%)':'translate(22%, 30%)',
                        height:'70px'
                    }} item sm={11} xs={11} container alignItems={"center"}
                          justify={hasDetails?"space-around":'center'} >
                        {
                            hasDetails &&
                            <Grid container alignItems={"center"} justify={"center"} sm={5} xs={5}
                                  onClick={() =>
                                      this.props.history.push(`winners-table/${id}`)                                  }
                            >
                                    <StartButton data={winnerTableButton}/>
                            </Grid>
                        }
                        <Grid container alignItems={"center"} justify={"center"} sm={5} xs={5}
                              onClick={()=>{
                                  if (gameStart)
                                      this.sessionNew(id,gameType)}}
                        >
                            {
                                (gameStart && picoSmallLoader) &&
                                <Grid sm={3} xs={3} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                      style={{position:'relative',height:'50px'}}
                                >
                                    <Grid item container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                        <PicoLoader/>
                                    </Grid>
                                </Grid>
                            }
                            {
                                (!gameStart || !picoSmallLoader ) &&
                                <StartButton data={startButton}/>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData
})
export default connect(mapStateToProps,{rxData})(withRouter (League))
